import { Skeleton } from '@/components/shared/shadcn-ui/skeleton';

const OrderCutoffTimesSkeleton = () => {
  return (
    <div className="flex flex-col gap-4">
      <Skeleton className="w-full h-[472px]" />
      <Skeleton className="w-full h-10" />
    </div>
  );
};

export default OrderCutoffTimesSkeleton;
